import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { TableColumn } from '@models/tableColumn';
import { plainToClass } from 'class-transformer';
import { Subscription, interval } from 'rxjs';
import '@angular/localize/init';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { TableOptions } from '@models/tableOptions';
import { DomSanitizer } from '@angular/platform-browser';
import { ManufacturerDto } from '@dto/manufacturerDto';
import { ManufacturersService } from '@services/entity/manufacturer.services';
import { Manufacturer } from '../../../models/manufacturer';
import { ManufacturersTableEntry } from '../../../dto/ManufacturersTableEntry';


@Component({
  selector: 'app-manufacturer-table',
  templateUrl: './manufacturer.component.html',
  styleUrls: ['./manufacturer.component.scss']
})

export class ManufacturerTableComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {

  public className = 'ManufacturerTableComponent';
  public manufacturer: ManufacturerDto;
  public activeComponentClassName: string = 'ManufacturersTableComponent';


  @Output() stationCount = new EventEmitter<number>();

  public entities: ManufacturersTableEntry[];
  public isOperatorView: boolean;
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public showAll: boolean = false;

  @Output() newEntityEvent = new EventEmitter<ManufacturerDto>();

  private sortParam: number;
  private isAnyCheckBoxSelected: boolean;

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@ChargingStationsTableColumn2:Name/Bezeichner`, property: 'name' },
  ];

  public tableOptions: TableOptions = { hideActions: true };

  constructor(
    public manufacturerService: ManufacturersService,
    public sanitizer: DomSanitizer,
    private dialog: NgbModal,
    injector: Injector
  ) {
    super(manufacturerService, injector);
  }


  ngOnInit(): void {
    this.getRoles();
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    this.showAll = this.activatedRoute.snapshot.data['showAll'];

    this.activatedRoute.queryParams.subscribe(params => {
      this.sortParam = params.sort;
    });
    super.ngOnInit();

    if(!this.sortParam) {
      this.tableFunctions.sortColumn = 'name';
      this.tableFunctions.sortDirection = 'asc';
    }
  }

  onSort() {
    if (this.sortParam) {
      this.sortParam = undefined;
      this.router.navigate([], {
        queryParams: {
          'sort': null,
        },
        queryParamsHandling: 'merge'
      })
    }
  }

  async initializeEntities() {
    if (this.isOperatorView) {
      if (this.showAll) {
        this.manufacturerService.getAllManufacturer().subscribe(result => {
          this.entities = plainToClass(Manufacturer, result);
          this.stationCount.emit(this.entities.length)
          super.setupTable();
        }, error => { });
        this.tableOptions = { hideActions: true };
      }
    }
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  matches(entity: ManufacturerDto, term: string) {
    return ManufacturersService.matches(entity, term);
  }

}
